<template>
  <a-modal
    :title="`${editProTit}：${projectItemData.projectname}`"
    :visible.sync="isLimitDialogShow"
    width="506px"
    class="edit-limit-dialog"
    :ok-text="okTTxt"
    :cancel-text="cancelTxt"
    :mask-closable="false"
    :confirm-loading="confirmLoading"
    @ok="submitHandle"
    @cancel="isLimitDialogShow=false"
  >
    <div class="creat-dilog-form">
      <a-form
        ref="editForm"
        :form="form"
        :hide-required-mark="true"
        class="demo-form-inline"
      >
        <a-form-item
          :label="`${projectNameTit}：`"
          :label-col="{ span: 5 }"
          :wrapper-col="{ span: 16 }"
          class="total-input-box"
        >
          <a-input
            v-decorator="['projectname', { rules: [
              { required: true, message: projectnamePlace, trigger: 'blur' }
            ] ,initialValue: projectname}]"
            type="text"
            :placeholder="projectnamePlace"
            :maxlength="20"
            @change="getValue"
          />
          <span class="input-length-num">{{ valData?valData.length: 0 }}/20</span>
        </a-form-item>
        <a-form-item
          v-if="!isMember"
          :label-col="{ span: 5 }"
          :wrapper-col="{ span: 16 }"
          :label="`${chargeTit}：`"
        >
          {{ $t('message["1324"]') }}
        </a-form-item>
      </a-form>
    </div>
  </a-modal>
</template>
<script>
import { mapActions, mapState } from 'vuex'
export default {
  props: {
    projectItemData: {
      type: Object,
      default () {
        return {}
      }
    }
  },
  data () {
    return {
      submiting: false,
      isLimitDialogShow: false,
      confirmLoading: false,
      valData: this.projectItemData.projectname
    }
  },
  computed: {
    ...mapState('organization/org', ['decorators']),
    projectname () {
      return this.projectItemData.projectname
    },
    isMember () {
      return this.$route.query.type === 'member'
    },
    editForm () {
      return {
        cid: this.projectItemData.cid,
        projectid: this.projectItemData.projectid,
        pType: this.isMember ? 2 : 1
      }
    },
    chargeTit () {
      return this.$t('message["330"]')
    },
    projectnamePlace () {
      return this.$t('message["814"]')
    },
    cancelTxt () {
      return this.$t('message["896"]')
    },
    okTTxt () {
      return this.$t('message["926"]')
    },
    projectNameTit () {
      return this.$t('message["1325"]')
    },
    editProTit () {
      return this.$t('message["1398"]')
    }
  },
  mounted () {

  },
  created () {
    this.form = this.$form.createForm(this)
  },
  methods: {
    ...mapActions('organization/org', ['ajaxEditPro']),
    changeVisible (isShow) {
      this.isLimitDialogShow = isShow
    },
    // validLen (rule, value, callback) {
    //   if (value && (value.replace(/[\u4E00-\u9FA5]/g, 'aa').length > 16)) {
    //     callback(new Error('项目名称最多8位汉字或者16位数字和字母'))
    //   } else {
    //     callback()
    //   }
    // },
    submitHandle (formName) {
      this.form.validateFieldsAndScroll(async (err, values) => {
        if (!err) {
          const formDatas = Object.assign(values, this.editForm)
          const chain = await this.ajaxEditPro({ cid: this.projectItemData.cid })
          chain.params(formDatas)
            .setForm(this.form)
            .fetch()
          this.form.resetFields()
          this.isLimitDialogShow = false
        }
      })
    },
    getValue (e) {
      this.valData = e.target.value
    }

  }
}
</script>
<style scoped>
.input-length-num {
  position: absolute;
  right: 6px;
  top: -8px;
}
</style>
